import React, { useState } from "react";
import axios from "axios";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import DemoParinted from "../../../../../../templates/ApplicationDetails/components/RichTextArea";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const RibbonMessage = () => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const userInfo = Digit.UserService.getUser();
  const authToken = userInfo?.access_token;
  const tenantId = Digit.ULBService.getCurrentTenantId();

  const saveRibbon = async (description) => {
    setLoading(true);

    const payload = {
      UserManual: [
        {
          tenantId,
          sno: "1",
          category: "RIBBON",
          description,
          isApproved: "RIBBON_MESSAGE",
          isSubApproved: "",
          subCategory: "",
          downloadLink: "",
        },
      ],
      RequestInfo: {
        apiId: "Rainmaker",
        authToken,
        userInfo,
        msgId: `${Date.now()}|en_IN`,
      },
    };

    try {
      await axios.post(Urls.UserManualCreate, payload, {
        headers: { "Content-Type": "application/json" },
      });

      console.info(description ? "Ribbon message published" : "Ribbon message removed");

      setMessage("");
    } catch (e) {
      console.error("Ribbon action failed", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" gutterBottom>
        🚨 Ribbon Message
      </Typography>

      <DemoParinted content={message} setContent={setMessage} />

      <Box mt={3} display="flex" gap={2}>
        <Button
          variant="contained"
          color="error"
          disabled={loading}
          onClick={() => {
            if (!message.trim()) return;
            saveRibbon(message);
          }}
        >
          {loading ? <CircularProgress size={22} /> : "Publish"}
        </Button>

        <Button variant="outlined" color="secondary" disabled={loading} onClick={() => saveRibbon("")}>
          Remove from Homepage
        </Button>
      </Box>
    </Box>
  );
};

export default RibbonMessage;
